// Production 환경에서 console 로그 비활성화 (모든 모듈보다 먼저 실행)
if (process.env.NODE_ENV === 'production') {
  console.log = () => {};
  console.info = () => {};
  console.debug = () => {};
  console.trace = () => {};
  // console.warn과 console.error는 중요한 에러 정보이므로 유지
}
